import BillingDashboard from "./BillingDashboard";

export default BillingDashboard;